<template>
  <div class="application review">
    <div class="questions">
      <div class="question">
        <p class="title">Review</p>

        <div class="block">
          <p class="phase">{{ phase_name }}</p>
          <template v-for="(value, key) in answers">
            <div class="item">
              <p>
                {{ labels[key] }}
                <span>
                  {{ answers[key].length }}
                  {{ answers[key].length > 1 ? "Uploads" : "Upload" }}
                </span>
                <img @click="edit(phase, answers, key)" class="edit" src="@/assets/img/edit.svg" />
              </p>
            </div>
          </template>
        </div>

        <button @click="sendApplication()" class="btn">Send Documents</button>
      </div>
    </div>

    <transition name="fade">
      <div v-if="edit_screen" class="popup">
        <div class="offclick" @click="edit_screen = false"></div>
        <div class="holder">
          <questions
            :currentCategory="currentCategory"
            :currentQuestion="currentQuestion"
            :question="questions"
            v-on:updateAnswer="updateAnswer"
          ></questions>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <saving-info
        v-if="save_info_screen"
        title="Sending your Application!"
        body="Please wait a moment while we send your application."
      ></saving-info>
    </transition>
  </div>
</template>

<script>
import { db, functions } from "@/config/firebaseInit";
import Section from "@/components/Application/Section";
import Questions from "@/components/Application/QuestionsEdit";
import QuestionsList from "@/components/Application/Forms.json";
import SavingInfo from "@/components/Application/SavingInfo";

export default {
  name: "Review",
  props: ["phase", "phase_name"],
  components: {
    "intro-section": Section,
    questions: Questions,
    "saving-info": SavingInfo
  },
  data() {
    return {
      questions: QuestionsList,
      currentQuestion: "",
      currentCategory: "",
      user: this.$store.state.user,
      answers: this.$store.state.answers,
      labels: {},
      save_info_screen: false,
      edit_screen: false,
      sendEmail: functions.httpsCallable("sendEmail")
    };
  },
  created() {
    this.getLabels(this.phase);
    this.user.progress = 100;
  },
  methods: {
    getLabels(phase) {
      this.questions[this.phase].forEach(question => {
        let key;
        for (key in question.inputs) {
          if (question.inputs[key].label) {
            this.labels[key] = question.inputs[key].label;
          } else {
            this.labels[key] = question.question;
          }
        }
      });
    },
    updateAnswer(answer, key) {
      this.user[this.currentCategory][key] = answer;
      this.edit_screen = false;
    },
    edit(category, section, key) {
      this.edit_screen = true;
      this.currentCategory = category;
      if (category == "businessBasics") category = "business";
      let questions = this.questions[category].filter(qs => qs.inputs[key]);
      this.currentQuestion = questions[0];
    },
    sendApplication() {
      let user = this.$store.state.user;
      let data = {};
      data[this.phase] = "review";
      this.save_info_screen = true;
      db.collection("user")
        .doc(this.$store.state.user_id)
        .set(data, { merge: true })
        .then(doc => {
          this.saveAnswers();
        });
    },
    saveAnswers() {
      let data = this.$store.state.answers;
      data.created_at = Date.now();
      db.collection("user")
        .doc(this.$store.state.user_id)
        .collection(this.phase)
        .doc(this.$store.state.tempId)
        .set(data)
        .then(doc => {
          this.sendUserEmail();
          this.sendAdminEmail();
          this.$store.commit("setApplicationApprovalStep", 1);
          setTimeout(() => {
            this.$parent.step = null;
            setTimeout(() => {
              this.$parent.step = "complete";
              this.$store.commit("setAnswers", null);
              this.$store.commit("setProgress", 0);
            }, 500);
          }, 7000);
        });
    },
    sendUserEmail() {
      let vm = this;
      return Promise.all([
        this.sendEmail({
          template_name: "equfi-application-confirmation",
          from_email: null,
          to_email: [
            {
              email: vm.$store.state.user.start.email,
              type: "to"
            }
          ],
          global_merge_vars: [
            {
              name: "name",
              content: vm.$store.state.user.start.full_name
            },
            {
              name: "phase",
              content: vm.phase_name
            }
          ]
        })
      ]);
    },
    sendAdminEmail() {
      let vm = this;
      return Promise.all([
        this.sendEmail({
          template_name: "equfi-documents-review",
          subject: "Someone has finished Application approval!",
          from_email: null,
          to_email: [
            {
              email: "sam@samsonstages.com",
              type: "to"
            }
          ],
          global_merge_vars: [
            {
              name: "name",
              content: vm.$store.state.user.start.full_name
            },
            {
              name: "email",
              content: vm.$store.state.user.start.email
            },
            {
              name: "company",
              content: vm.$store.state.user.businessBasics.business_name
            },
            {
              name: "loan",
              content: "$" + vm.$store.state.user.start.amount_needed
            },
            {
              name: "application_url",
              content:
                "https://equfiloans.com/applications/" + vm.$store.state.user_id
            }
          ]
        })
      ]);
    }
  }
};
</script>

<style lang="scss">
.intro {
  height: auto;
  min-height: 100vh;
  background: rgba(11, 110, 251, 0.08);
  width: 100%;
  text-align: center;
  .contain {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
    max-width: 700px;
    .icon {
      height: 70px;
      margin-bottom: 30px;
    }
    h1 {
      font-size: 50px;
    }
  }
}

.review {
  margin-top: 0;
  background: rgba(11, 110, 251, 0.08);
  .questions {
    max-width: 450px;
    width: 100%;
    margin: auto;
    margin-top: 0 !important;
    .question {
      padding: 30px;
      background: transparent;
      .title {
        margin: 0;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 25px;
      }
      .block {
        margin-bottom: 30px;
        width: 100%;
        background: white;
        padding: 20px;
        p.phase {
          margin-top: 0;
          font-size: 17px;
          border-bottom: 2px solid #2196f3;
          padding-bottom: 5px;
        }
        .item {
          padding: 8px 0;
          border-bottom: 1px solid #eaeaea;
          &:last-child {
            border-bottom: none;
          }
          p {
            position: relative;
            margin: 0;
            font-size: 14px;
            display: flex;
            font-weight: bold;
            justify-content: space-between;
            align-items: center;
            span {
              padding: 0 20px;
              font-size: 13px;
              font-weight: normal;
              text-align: right;
            }
            .edit {
              position: absolute;
              right: -6px;
              height: 23px;
              cursor: pointer;
              padding: 5px;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  z-index: 99;
  justify-content: center;
  align-items: center;
  .offclick {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.7);
  }
  .holder {
    position: relative;
    z-index: 2;
    background: #f1f6ff;
    padding: 30px;
    width: 100%;
    max-width: 450px;
    max-height: 90%;
    height: auto;
    overflow: hidden;
    overflow-y: auto;
  }
}
</style>
